export default function trackDownloads() {
    const log = event => {
        window.console.log(event);
    };

    const postData = (url, userGuid, fileGuid) =>
        new Promise((resolve, reject) => {
            if (!userGuid) {
                reject('Error: userGuid is missing!');
                return;
            }

            if (!fileGuid) {
                reject('Error: fileGuid is missing!');
                return;
            }

            var xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.setRequestHeader('Content-Type', 'application/json');

            xhr.addEventListener('load', () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.response);
                } else {
                    let message = `Error: ${xhr.status} - ${xhr.statusText}. Message: ${xhr.responseText}.`;

                    reject(message);
                }
            });

            xhr.addEventListener('error', () => reject(xhr.statusText));
            xhr.addEventListener('abort', () => reject(xhr.statusText));
            xhr.addEventListener('timeout', () => reject(xhr.statusText));

            xhr.send(
                JSON.stringify({
                    userGuid: userGuid,
                    documentGuid: fileGuid
                })
            );
        });

    const init = () => {
        let config = {
            trackSDSUrl: '/api/productdocument/trackdownload',
            cssClass: 'track-download'
        };

        let buttons = document.getElementsByClassName(config.cssClass);

        for (let i = 0; i < buttons.length; i++) {
            let button = buttons[i];

            button.addEventListener('click', e => {
                //only run on the first click (made by user), not the one triggered below
                if (button.dataset['alreadyTracked'] !== 'true') {
                    button.dataset['alreadyTracked'] = 'true';
                    e.preventDefault();

                    let fileGuid = button.dataset['fileGuid'];
                    let userGuid = button.dataset['userGuid'];

                    postData(config.trackSDSUrl, userGuid, fileGuid)
                        .then(response => {
                            log(response);
                        })
                        .catch(error => {
                            log(error);
                        })
                        .finally(() => {
                            button.click();
                        });
                }
            });
        }
    };

    const docReady = fn => {
        // see if DOM is already available
        if (
            document.readyState === 'complete' ||
            document.readyState === 'interactive'
        ) {
            // call on next available tick
            setTimeout(fn, 1);
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    };

    //run on 'document ready' event
    docReady(() => {
        init();
    });
}

trackDownloads();
